
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("fmx3D", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ecc07c3ee093eb1b$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Brazil)
var $ecc07c3ee093eb1b$export$2e2bcd8739ae039 = {
    'people.menu.renotify.flag.description': "A gente est\xe1 mandando um lembrete para todos. Pode levar at\xe9 um minuto.",
    'people.menu.renotify.flag.description.confluence': 'Lembrar colegas de equipe',
    'people.menu.renotify.flag.title': 'Enviando lembretes',
    'people.menu.renotify.flag.title.confluence': 'Reenviando o e-mail de convite',
    'people.menu.renotify.menu.description': "{userCount, plural, one {{userCount,number} pessoa n\xe3o aceitou o convite para {product}. Saiba quem est\xe1 faltando e envie um lembrete.} other {{userCount,number} pessoas n\xe3o aceitaram o convite para {product}. Saiba quem est\xe1 faltando e envie um lembrete.}}",
    'people.menu.renotify.menu.description.confluence': "Algumas pessoas n\xe3o aceitaram o convite para o Confluence. Saiba quem est\xe1 faltando e envie um lembrete.",
    'people.menu.renotify.menu.dismiss': 'Ignorar',
    'people.menu.renotify.menu.dismiss.confluence': "Agora n\xe3o",
    'people.menu.renotify.menu.remind': 'Lembrar membros da equipe',
    'people.menu.renotify.menu.remind.confluence': 'Lembrar colegas de equipe',
    'people.menu.renotify.menu.title': "Todos est\xe3o participando?",
    'people.menu.renotify.modal.copied': 'Link copiado',
    'people.menu.renotify.modal.copy': 'Copiar link do convite',
    'people.menu.renotify.modal.description': "A gente pode mandar um lembrete aos membros ausentes ou voc\xea pode compartilhar o link de convite com eles.",
    'people.menu.renotify.modal.description.confluence': 'Envie o e-mail de convite de novo ou copie e compartilhe o link do convite.',
    'people.menu.renotify.modal.dismiss': 'Cancelar',
    'people.menu.renotify.modal.resend': 'Enviar lembrete',
    'people.menu.renotify.modal.resend.confluence': 'Reenviar convite',
    'people.menu.renotify.modal.title': 'Lembre os membros ausentes',
    'people.menu.renotify.modal.title.confluence': 'Lembre os colegas de equipe que faltam',
    'ptc.pm.collaborators.title': 'Seus colaboradores',
    'ptc.pm.error-heading': 'Algo de errado aconteceu',
    'ptc.pm.error-image-alt-text': "Um rob\xf4 quebrado e v\xe1rias pessoas ocupadas em seu conserto.",
    'ptc.pm.error-text': "N\xf3s acompanhamos esses erros, mas n\xe3o hesite em entrar em contato se a atualiza\xe7\xe3o n\xe3o corrigir as coisas",
    'ptc.pm.num-members': '{memberCount, plural, one {{memberCount,number} membro} other {{memberCount,number} membros}}',
    'ptc.pm.people': 'Pessoas',
    'ptc.pm.teams': 'Equipes',
    'ptc.pm.view-your-profile': 'Exibir seu perfil',
    'ptc.pm.your-teams.title': 'Suas equipes'
};

});


//# sourceMappingURL=pt_BR.b9f64f1a.js.map
